<script setup lang="ts">
    import { computed, nextTick, ref, watch } from 'vue';
    import { __ } from '../stores/expressions';
    import Modal, { ModalSize } from './Modal.vue';
    import { useAskMeStore } from '../stores/ask-me';
    import { useRoute } from 'vue-router';

    const ask_me = useAskMeStore();
    const route = useRoute();

    const props = defineProps({
        show: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits<{
        (e: 'close'): void;
    }>();

    const filter = ref('');

    const search_input = ref<HTMLInputElement | null>(null);

    const filteredChats = computed(() => {
        return ask_me.recentChats
            .map((item) => {
                return {
                    ...item,
                    chats: item.chats.filter((chat) =>
                        chat.title.toLowerCase().includes(filter.value.toLowerCase() || '')
                    ),
                };
            })
            .filter((item) => item.chats.length > 0);
    });

    watch(
        () => props.show,
        (show) => {
            if (show) {
                nextTick(() => {
                    search_input.value?.focus();
                });
            }
        },
        { immediate: true }
    );

    watch(
        () => route.path,
        () => {
            filter.value = '';
            emit('close');
        }
    );
</script>

<template>
    <Modal
        :show="show"
        :fixed-height="true"
        :padding="false"
        :size="ModalSize.Small"
        @close="emit('close')"
    >
        <div class="flex flex-col h-full">
            <div
                class="border-0 p-2 pr-10 border-b border-gray-light"
                @click="search_input?.focus()"
            >
                <input
                    ref="search_input"
                    v-model="filter"
                    type="text"
                    :aria-label="__('search-chats')"
                    class="rounded-lg border-0 ring-0 w-full"
                    :placeholder="__('search-chats')"
                />
            </div>

            <div class="overflow-y-scroll custom-scrollbar flex-grow">
                <ul>
                    <li v-for="item in filteredChats" :key="item.group">
                        <h3 class="font-semibold text-sm px-4 mt-7 first-letter:capitalize mb-1">
                            {{ item.group }}
                        </h3>
                        <ul>
                            <li v-for="chat in item.chats" :key="chat.id" class="px-2">
                                <RouterLink
                                    :to="'/ask-me/' + chat.id"
                                    class="peer px-2 py-1.5 block text-sm rounded-md custom-focus hover:bg-gray-lightest focus:bg-gray-lightest"
                                    active-class="opacity-25 pointer-events-none"
                                >
                                    {{ chat.title }}
                                </RouterLink>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </Modal>
</template>
